import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-carbon py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-267" data-mp="3fycofh2u5v85">
      <div className="mx-auto max-w-6xl px-4" data-id="element-268" data-mp="3azjdnwexoibo">
        <SectionHeading id="reviews-title" data-id="element-269" data-mp="3ayqcrc2non1g">Testimonials from Educators Using This Teacher Ready</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-270" data-mp="31zw9x3yqf0fg">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-lava/20 bg-petrol p-6 shadow-lg shadow-black/30" data-id="element-271" data-mp="2x006b5ty5b0f" data-mpi={index}>
              <div className="flex text-energy" aria-label="5 out of 5 stars" data-id="element-272" data-mp="h555fnoyd5q8">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-273" data-mp="77s6dvyzi4y8" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-274" data-mp="c622q9wg3blf">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-275" data-mp="zw656dxwd5au">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-lava/40 bg-carbon text-sm font-extrabold text-lava" data-id="element-276" data-mp="14w28sc2omupv">
                  {initials}
                </span>
                <span data-id="element-277" data-mp="v4o47pvvj4pv">
                  <b className="block text-sm text-snow" data-id="element-278" data-mp="v44yr8neu8sq">{name}</b>
                  <small className="text-xs text-muted" data-id="element-279" data-mp="1iv1xtku3xbmk">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}